// client/src/utils/pdf_cache_setup.js

// PDF CACHE SERVICE (IndexedDB)
const DB_NAME = 'alpherra_db';
const STORE_NAME = 'pdf_cache';
const DB_VERSION = 1;

// Initialize IndexedDB
const initDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
    
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        // Create store with composite key: turnId + version
        db.createObjectStore(STORE_NAME, { keyPath: 'cacheKey' });
      }
    };
  });
};

// Save PDF to cache
export const savePDFToCache = async (turnId, version, pdfBlob) => {
  try {
    const db = await initDB();
    const store = db.transaction(STORE_NAME, 'readwrite').objectStore(STORE_NAME);
    
    const cacheKey = `${turnId}_v${version}`;
    
    await store.put({
      cacheKey,
      turnId,
      version,
      blob: pdfBlob,
      timestamp: new Date().getTime(),
      fileName: `Alpherra_Report_v${version}.pdf`
    });
    
    console.log('✅ PDF cached:', cacheKey);
    return cacheKey;
  } catch (error) {
    console.error('❌ Error saving PDF to cache:', error);
    throw error;
  }
};

// Retrieve PDF from cache
export const getPDFFromCache = async (turnId, version) => {
  try {
    const db = await initDB();
    const store = db.transaction(STORE_NAME, 'readonly').objectStore(STORE_NAME);
    
    const cacheKey = `${turnId}_v${version}`;
    const result = await new Promise((resolve, reject) => {
      const request = store.get(cacheKey);
      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
    
    if (result) {
      console.log('✅ PDF retrieved from cache:', cacheKey);
      return result;
    } else {
      console.log('⚠️ PDF not found in cache:', cacheKey);
      return null;
    }
  } catch (error) {
    console.error('❌ Error retrieving PDF from cache:', error);
    throw error;
  }
};

// Download PDF from cache
export const downloadPDFFromCache = async (turnId, version) => {
  try {
    const cachedData = await getPDFFromCache(turnId, version);
    
    if (!cachedData) {
      throw new Error('PDF not found in cache. Please regenerate.');
    }
    
    const url = window.URL.createObjectURL(cachedData.blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = cachedData.fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    
    console.log('✅ PDF downloaded from cache');
  } catch (error) {
    console.error('❌ Error downloading PDF from cache:', error);
    throw error;
  }
};

// Clear cache for specific report
export const clearPDFCache = async (turnId, version) => {
  try {
    const db = await initDB();
    const store = db.transaction(STORE_NAME, 'readwrite').objectStore(STORE_NAME);
    const cacheKey = `${turnId}_v${version}`;
    
    await store.delete(cacheKey);
    console.log('✅ Cache cleared for:', cacheKey);
  } catch (error) {
    console.error('❌ Error clearing cache:', error);
  }
};

// Clear all cache
export const clearAllPDFCache = async () => {
  try {
    const db = await initDB();
    const store = db.transaction(STORE_NAME, 'readwrite').objectStore(STORE_NAME);
    
    await store.clear();
    console.log('✅ All PDF cache cleared');
  } catch (error) {
    console.error('❌ Error clearing all cache:', error);
  }
};
